import HTMLReactParser from 'html-react-parser';
import type { HTMLReactParserOptions } from 'html-react-parser';

export const asHtml = (html: string, options?: HTMLReactParserOptions) =>
  HTMLReactParser(html, options);
